import React from 'react'
import { Box, MenuItem, Select } from '@mui/material'
import { useAtom, useAtomValue } from 'infrastructure/state/jotai.wrapper'
import {
  copySourceNodeAtom,
  selectedDestinationSiblingId,
  selectedNodeAtom,
} from './atoms'

export function CopyMovePreview({ action }: { action: string }) {
  const destParent = useAtomValue(selectedNodeAtom)
  const sourceNode = useAtomValue(copySourceNodeAtom)
  if (!destParent || !sourceNode) return null
  return (
    <Box padding="20px" border={'1px solid'} borderRadius="5px">
      <Box paddingBottom="10px">
        {action} From:{' '}
        <strong>
          {sourceNode.type}: {sourceNode.title}
        </strong>
      </Box>
      <Box paddingBottom="10px">
        {action} to:{' '}
        <strong>
          {destParent.type}: {destParent.title}
        </strong>
      </Box>
      <Box>
        Coming Before: <SiblingSelect />
      </Box>
    </Box>
  )
}

function SiblingSelect() {
  const sourceNode = useAtomValue(copySourceNodeAtom)
  const destParent = useAtomValue(selectedNodeAtom)
  const [siblingId, setSiblingId] = useAtom(selectedDestinationSiblingId)

  if (!destParent || !destParent.nodes.length) return 'Only child node'

  return (
    <Select
      displayEmpty={true}
      value={siblingId ?? ''}
      onChange={({ target: { value } }) => setSiblingId(value)}
    >
      <MenuItem selected={!siblingId} value="">
        Last Child Item
      </MenuItem>
      {destParent.nodes.map((n) => {
        return (
          <MenuItem
            key={n.id}
            selected={siblingId === n.id}
            value={n.id}
            disabled={n.id === sourceNode?.id}
          >
            {n.type}: {n.title}
          </MenuItem>
        )
      })}
    </Select>
  )
}
